import { Layout } from "@mirage/mosaics/Layout";
import { DashSpinnerAutofitContainer } from "@mirage/shared/dash-spinner/DashSpinnerAutofitContainer";
import { Suspense } from "react";

interface WebLayoutProps {
  hideTopNav?: boolean;
}
export const WebLayout: React.FC<WebLayoutProps> = ({
  children,
  hideTopNav,
}) => {
  return (
    <Layout
      betaBadgePosition="top"
      globalNavAlwaysCollapsed={false}
      hideTopNav={hideTopNav}
    >
      {/* Keep the spinner inside the layout so that it doesn't flicker the page */}
      <Suspense fallback={<DashSpinnerAutofitContainer />}>{children}</Suspense>
    </Layout>
  );
};
